import { forwardRef } from "react";
import { cn } from "../../lib/cn.js";

const Skeleton = forwardRef(
  (
    {
      className,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          "animate-pulse rounded-xl bg-[var(--color-warm-200)]",
          className
        )}
        {...props}
      />
    );
  }
);

Skeleton.displayName = "Skeleton";

export default Skeleton;